import React from 'react';
import { Check, CreditCard, Star } from 'lucide-react';
import { Section, SectionTitle, CTAButton } from './Shared';
export function Offer() {
  return <div id="oferta" className="bg-cream" data-id="element-122">
      <Section className="max-w-4xl" data-id="element-123">
        <div className="bg-white rounded-3xl shadow-xl border border-beige-muted overflow-hidden" data-id="element-124">
          {/* Header */}
          <div className="bg-sage p-8 md:p-10 text-center" data-id="element-125">
            <h3 className="text-white font-bold text-2xl md:text-3xl font-playfair" data-id="element-126">
              HOY TENÉS ACCESO COMPLETO AL MÉTODO
            </h3>
          </div>

          {/* Body */}
          <div className="p-8 md:p-12 flex flex-col items-center text-center" data-id="element-127">
            {/* Price Block */}
            <div className="mb-4" data-id="element-128">
              <p className="text-charcoal-light line-through text-xl mb-2" data-id="element-129">
                Antes $29.980
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-130">
                <span className="bg-cta/10 text-cta font-bold px-3 py-1 rounded-md text-sm uppercase tracking-wider" data-id="element-131">
                  Hoy
                </span>
                <span className="text-5xl md:text-6xl font-playfair text-charcoal font-bold" data-id="element-132">
                  $14.990
                </span>
                <span className="text-charcoal-light font-medium text-lg" data-id="element-133">
                  ARS
                </span>
              </div>
            </div>

            <p className="text-charcoal-light italic mb-2" data-id="element-134">
              Menos de lo que cuesta una sola consulta…
            </p>
            <p className="text-charcoal-light mb-8 max-w-md" data-id="element-135">
              pero con un sistema que podés aplicar todos los días en tu casa.
            </p>

            {/* Includes */}
            <div className="space-y-4 mb-8 text-left w-full max-w-sm mx-auto" data-id="element-136">
              <div className="flex items-center gap-3" data-id="element-137">
                <Check className="w-5 h-5 text-cta flex-shrink-0" data-id="element-138" />
                <span className="text-charcoal font-medium" data-id="element-139">
                  Método completo paso a paso
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-140">
                <Check className="w-5 h-5 text-cta flex-shrink-0" data-id="element-141" />
                <span className="text-charcoal font-medium" data-id="element-142">
                  3 bonos incluidos GRATIS
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-143">
                <Check className="w-5 h-5 text-cta flex-shrink-0" data-id="element-144" />
                <span className="text-charcoal font-medium" data-id="element-145">
                  Acceso inmediato después del pago
                </span>
              </div>
            </div>

            {/* Payment Info */}
            <div className="space-y-2 mb-8" data-id="element-146">
              <div className="flex items-center justify-center gap-2 text-charcoal-light" data-id="element-147">
                <CreditCard className="w-5 h-5 text-sage-dark" data-id="element-148" />
                <span className="font-medium" data-id="element-149">
                  Podés pagar con Mercado Pago
                </span>
              </div>
              <p className="text-charcoal-light font-medium" data-id="element-150">
                💳 3 cuotas sin interés disponibles
              </p>
            </div>

            {/* Micro trust block */}
            <div className="bg-cream-dark rounded-xl p-5 mb-8 w-full max-w-sm mx-auto text-left space-y-3" data-id="element-151">
              <div className="flex items-center gap-3" data-id="element-152">
                <Check className="w-5 h-5 text-cta flex-shrink-0" data-id="element-153" />
                <span className="text-charcoal text-sm font-medium" data-id="element-154">
                  Acceso inmediato
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-155">
                <Check className="w-5 h-5 text-cta flex-shrink-0" data-id="element-156" />
                <span className="text-charcoal text-sm font-medium" data-id="element-157">
                  Funciona aunque ya probaste otros métodos
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-158">
                <Check className="w-5 h-5 text-cta flex-shrink-0" data-id="element-159" />
                <span className="text-charcoal text-sm font-medium" data-id="element-160">
                  Sin dejar llorar a tu bebé
                </span>
              </div>
            </div>

            {/* CTA */}
            <CTAButton className="w-full md:w-auto mb-6 px-10 py-5 text-lg" data-id="element-161">
              👉 SÍ, QUIERO EMPEZAR HOY Y DORMIR MEJOR
            </CTAButton>

            {/* Social Proof */}
            <p className="text-sm text-charcoal-light font-medium" data-id="element-162">
              ⭐ Más de 1.000 mamás ya lograron que sus bebés duerman mejor
            </p>
          </div>
        </div>
      </Section>
    </div>;
}